import {IntlProvider} from 'react-intl';
import translations from '../../res/translations';

export default (locale) => {
    const intlProvider = new IntlProvider({locale: locale, messages: translations[locale.substring(0, 2)]}, {});
    return intlProvider.state.intl;
};
